import { render, staticRenderFns } from "./ConfirmacaoCadastro.vue?vue&type=template&id=8d8b305c&scoped=true"
import script from "./ConfirmacaoCadastro.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoCadastro.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoCadastro.vue?vue&type=style&index=0&id=8d8b305c&prod&lang=scss&scoped=true"
import style1 from "./ConfirmacaoCadastro.vue?vue&type=style&index=1&id=8d8b305c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b305c",
  null
  
)

export default component.exports